// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-home-page {
  --ink: #102033;
  --muted: #4b6179;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at top left, rgba(245, 162, 93, 0.32) 0%, rgba(245, 162, 93, 0) 28%), radial-gradient(circle at 90% 12%, rgba(72, 136, 222, 0.2) 0%, rgba(72, 136, 222, 0) 24%), radial-gradient(circle at bottom right, rgba(18, 117, 161, 0.24) 0%, rgba(18, 117, 161, 0) 32%), linear-gradient(180deg, #fff7ec 0%, #f6f3ef 38%, #e7edf4 100%);
  padding: 24px 18px 40px;
  box-sizing: border-box;
}

.mobile-home-shell {
  position: relative;
  z-index: 1;
  max-width: 520px;
  margin: 0 auto;
}

.mobile-home-mobile-layout {
  display: block;
}

.desktop-home-layout {
  display: none;
}

.mobile-home-top-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 16px;
}

.mobile-home-top-button {
  border: 0;
  border-radius: 999px;
  padding: 12px 16px;
  cursor: pointer;
  background: linear-gradient(135deg, #193e6d 0%, #2c73c6 100%);
  color: #fff9f0;
  font: 700 0.9rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  box-shadow: 0 12px 28px rgba(22, 53, 92, 0.18);
}

.mobile-home-top-button-secondary {
  background: rgba(255, 255, 255, 0.78);
  color: #163355;
}

.mobile-home-hero {
  position: relative;
  overflow: hidden;
  display: grid;
  gap: 18px;
  margin-bottom: 18px;
  padding: 28px 24px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 34px;
  background: linear-gradient(145deg, rgba(13, 24, 41, 0.97) 0%, rgba(26, 59, 95, 0.93) 44%, rgba(201, 101, 48, 0.84) 100%);
  color: #fffaf2;
  box-shadow: 0 28px 60px rgba(17, 32, 53, 0.24);
}

.mobile-home-hero::before {
  content: "";
  position: absolute;
  inset: auto -60px -90px auto;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 214, 162, 0.26) 0%, rgba(255, 214, 162, 0) 70%);
}

.mobile-home-hero-copy,
.mobile-home-hero-panel {
  position: relative;
  z-index: 1;
}

.mobile-home-kicker {
  display: inline-flex;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffe7c9;
  font: 700 0.76rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.mobile-home-hero h1 {
  margin: 0 0 12px;
  font-family: "Trebuchet MS", "Gill Sans", sans-serif;
  font-size: clamp(2.25rem, 7vw, 4.4rem);
  line-height: 0.95;
  letter-spacing: -0.05em;
}

.mobile-home-hero p {
  margin: 0;
  color: rgba(255, 250, 242, 0.88);
  font: 500 1rem/1.6 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-hero-panel {
  display: grid;
  gap: 12px;
  padding: 16px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
}

.mobile-home-hero-stat {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.mobile-home-hero-stat strong {
  font: 800 2rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-hero-stat span,
.mobile-home-hero-tags span {
  color: rgba(255, 250, 242, 0.86);
}

.mobile-home-hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-home-hero-tags span {
  border-radius: 999px;
  padding: 8px 11px;
  background: rgba(255, 255, 255, 0.1);
  font: 700 0.82rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-intro-strip {
  display: grid;
  gap: 10px;
  margin-bottom: 18px;
  padding: 18px 4px 4px;
}

.mobile-home-section-label {
  display: inline-flex;
  color: #81563d;
  font: 700 0.78rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.mobile-home-intro-strip h2 {
  margin: 8px 0 0;
  color: #13263e;
  font: 800 clamp(1.5rem, 4vw, 2.2rem)/1.02 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: -0.04em;
}

.mobile-home-intro-strip p {
  margin: 0;
  color: #56687d;
  font: 500 0.98rem/1.55 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-visual-strip {
  display: grid;
  gap: 14px;
  margin-bottom: 16px;
}

.mobile-home-visual-card {
  position: relative;
  overflow: hidden;
  min-height: 170px;
  border-radius: 28px;
  box-shadow: 0 18px 36px rgba(28, 42, 67, 0.12);
}

.mobile-home-visual-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-home-visual-card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(10, 18, 30, 0.05) 0%, rgba(10, 18, 30, 0.68) 100%);
}

.mobile-home-visual-overlay {
  position: absolute;
  inset: auto 14px 14px 14px;
  z-index: 1;
  display: flex;
  align-items: end;
  gap: 12px;
  color: #fffaf2;
}

.mobile-home-visual-symbol {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(10px);
  font: 800 1.1rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-visual-label {
  display: block;
  margin-bottom: 4px;
  font: 700 0.72rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.82;
}

.mobile-home-visual-overlay h3 {
  margin: 0;
  font: 800 1.45rem/0.96 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: -0.04em;
}

.mobile-home-symbol-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.mobile-home-symbol-row span {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 10px 13px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 12px 24px rgba(28, 42, 67, 0.08);
  color: #1a3558;
  font: 700 0.82rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-footer {
  padding: 28px 0 6px;
  text-align: center;
}

.mobile-home-footer p {
  margin: 0;
  color: #17314f;
  font: 700 0.95rem/1.4 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-grid {
  display: grid;
  gap: 18px;
}

.mobile-home-card {
  position: relative;
  overflow: hidden;
  display: grid;
  gap: 12px;
  width: 100%;
  padding: 24px 20px;
  border: 0;
  border-radius: 28px;
  text-align: left;
  cursor: pointer;
  color: var(--ink);
  box-shadow: 0 18px 36px rgba(28, 42, 67, 0.13);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.mobile-home-card:hover,
.mobile-home-card:focus-visible {
  transform: translateY(-4px);
  box-shadow: 0 26px 48px rgba(28, 42, 67, 0.18);
  filter: saturate(1.04);
  outline: none;
}

.mobile-home-card::after {
  content: "";
  position: absolute;
  right: -18px;
  top: -30px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
}

.mobile-home-card-orb {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.28);
  z-index: 1;
}

.mobile-home-card h2,
.mobile-home-card p,
.mobile-home-card-eyebrow,
.mobile-home-card-cta,
.mobile-home-card-footer,
.mobile-home-card-meta {
  position: relative;
  z-index: 1;
}

.mobile-home-card-eyebrow {
  font: 700 0.76rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.78;
}

.mobile-home-card h2 {
  margin: 0;
  font-family: "Trebuchet MS", "Gill Sans", sans-serif;
  font-size: 1.7rem;
  line-height: 0.98;
  letter-spacing: -0.04em;
}

.mobile-home-card p {
  margin: 0;
  color: rgba(16, 32, 51, 0.8);
  font: 500 0.98rem/1.5 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}

.mobile-home-card-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.mobile-home-card-meta {
  color: rgba(16, 32, 51, 0.64);
  font: 700 0.82rem/1.2 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.mobile-home-card-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  width: fit-content;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(16, 32, 51, 0.1);
  font: 700 0.92rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
}

.mobile-home-card-cta-secondary {
  background: rgba(255, 255, 255, 0.52);
}

.mobile-home-card-sunrise {
  background: linear-gradient(145deg, #fff1d8 0%, #ffd9b3 55%, #ffc18e 100%);
}

.mobile-home-card-ocean {
  background: linear-gradient(145deg, #e7f7ff 0%, #cfeeff 50%, #a7d9fb 100%);
}

.mobile-home-card-ink {
  color: #f5f6fb;
  background: linear-gradient(145deg, #1a2740 0%, #233f63 55%, #31587b 100%);
}

.mobile-home-card-ink p,
.mobile-home-card-ink .mobile-home-card-eyebrow,
.mobile-home-card-ink .mobile-home-card-meta {
  color: rgba(245, 246, 251, 0.82);
}

.mobile-home-card-ink .mobile-home-card-cta {
  background: rgba(255, 255, 255, 0.12);
}

.mobile-home-card-copper {
  background: linear-gradient(145deg, #fff3ea 0%, #ffd8c3 52%, #f1ae8d 100%);
}

.mobile-home-card-forest {
  background: linear-gradient(145deg, #eef9ef 0%, #d0f0d7 52%, #b0deb6 100%);
}

.mobile-home-glow {
  position: absolute;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  filter: blur(22px);
  opacity: 0.44;
}

.mobile-home-glow-left {
  left: -80px;
  top: 40px;
  background: rgba(242, 166, 105, 0.5);
}

.mobile-home-glow-right {
  right: -90px;
  bottom: 60px;
  background: rgba(62, 146, 196, 0.38);
}

@media (min-width: 768px) {
  .mobile-home-page {
    padding: 38px 24px 54px;
  }
  .mobile-home-shell {
    max-width: 1180px;
  }
  .mobile-home-mobile-layout {
    display: none;
  }
  .desktop-home-layout {
    display: grid;
    gap: 22px;
  }
  .mobile-home-top-actions {
    justify-content: flex-end;
    margin-bottom: 18px;
  }
  .desktop-home-hero {
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(360px, 0.85fr);
    gap: 22px;
    align-items: stretch;
  }
  .desktop-home-copy,
  .desktop-home-spotlight,
  .desktop-home-tile {
    position: relative;
    overflow: hidden;
    border-radius: 34px;
    box-shadow: 0 28px 58px rgba(18, 31, 51, 0.15);
  }
  .desktop-home-copy {
    padding: 34px 34px 30px;
    color: #fffaf2;
    background: radial-gradient(circle at top right, rgba(253, 209, 151, 0.22) 0%, rgba(253, 209, 151, 0) 30%), linear-gradient(145deg, rgba(13, 24, 41, 0.98) 0%, rgba(24, 54, 90, 0.95) 58%, rgba(182, 93, 38, 0.86) 100%);
  }
  .desktop-home-copy h1 {
    margin: 0 0 14px;
    font: 800 clamp(3rem, 4vw, 4.9rem)/0.94 "Trebuchet MS", "Gill Sans", sans-serif;
    letter-spacing: -0.06em;
  }
  .desktop-home-copy p {
    max-width: 640px;
    margin: 0;
    color: rgba(255, 250, 242, 0.84);
    font: 500 1.02rem/1.7 "Trebuchet MS", "Gill Sans", sans-serif;
  }
  .desktop-home-actions {
    display: flex;
    gap: 12px;
    margin-top: 24px;
  }
  .desktop-home-symbol-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
  }
  .desktop-home-symbol-row span {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 10px 14px;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 250, 242, 0.9);
    font: 700 0.82rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
    letter-spacing: 0.04em;
  }
  .desktop-home-spotlight {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 12px;
    padding: 28px;
    color: #fff9f2;
  }
  .desktop-home-spotlight-primary {
    background: radial-gradient(circle at top left, rgba(255, 244, 210, 0.18) 0%, rgba(255, 244, 210, 0) 28%), linear-gradient(145deg, #13517f 0%, #0f3153 45%, #08233d 100%);
  }
  .desktop-home-spotlight h2 {
    margin: 0;
    font: 800 2.4rem/0.96 "Trebuchet MS", "Gill Sans", sans-serif;
    letter-spacing: -0.05em;
  }
  .desktop-home-photo-stack {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    margin-top: 8px;
  }
  .desktop-home-photo-card {
    position: relative;
    overflow: hidden;
    min-height: 180px;
    border-radius: 22px;
  }
  .desktop-home-photo-card img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .desktop-home-photo-card::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(8, 16, 30, 0.02) 0%, rgba(8, 16, 30, 0.62) 100%);
  }
  .desktop-home-photo-overlay {
    position: absolute;
    inset: auto 12px 12px 12px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: #fffaf2;
    font: 700 0.82rem/1.2 "Trebuchet MS", "Gill Sans", sans-serif;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  .desktop-home-photo-symbol {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    font-size: 1rem;
  }
  .desktop-home-spotlight p,
  .desktop-home-tile p {
    margin: 0;
    font: 500 1rem/1.6 "Trebuchet MS", "Gill Sans", sans-serif;
  }
  .desktop-home-spotlight-label {
    display: inline-flex;
    width: fit-content;
    border-radius: 999px;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.12);
    font: 700 0.75rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }
  .desktop-home-tile-link {
    width: fit-content;
    border: 0;
    border-radius: 999px;
    padding: 12px 16px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.14);
    color: #fff9f2;
    font: 700 0.92rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  }
  .desktop-home-tile-link-secondary {
    background: rgba(255, 255, 255, 0.24);
  }
  .desktop-home-mosaic {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 22px;
  }
  .desktop-home-tile {
    display: grid;
    gap: 12px;
    padding: 24px 24px 22px;
    text-align: left;
    border: 0;
    cursor: pointer;
    color: #13263e;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
  }
  .desktop-home-tile:hover,
  .desktop-home-tile:focus-visible {
    transform: translateY(-4px);
    box-shadow: 0 32px 62px rgba(18, 31, 51, 0.18);
    outline: none;
  }
  .desktop-home-tile:nth-child(1) {
    grid-column: span 4;
  }
  .desktop-home-tile:nth-child(2) {
    grid-column: span 4;
  }
  .desktop-home-tile:nth-child(3) {
    grid-column: span 4;
  }
  .desktop-home-tile:nth-child(4) {
    grid-column: span 12;
  }
  .desktop-home-tile h3 {
    margin: 0;
    font: 800 2rem/0.96 "Trebuchet MS", "Gill Sans", sans-serif;
    letter-spacing: -0.05em;
  }
  .desktop-home-tile-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
    margin-top: auto;
    font: 700 0.85rem/1.2 "Trebuchet MS", "Gill Sans", sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .desktop-home-tile-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
  }
  .desktop-home-arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    cursor: pointer;
    border-radius: 999px;
    padding: 10px 14px;
    background: rgba(16, 32, 51, 0.1);
  }
  .desktop-home-arrow-secondary {
    background: rgba(16, 32, 51, 0.06);
  }
  .desktop-home-tile-ocean {
    background: linear-gradient(145deg, #e8f7ff 0%, #cdeafe 50%, #aedcfa 100%);
  }
  .desktop-home-tile-ink {
    color: #f5f7fb;
    background: linear-gradient(145deg, #18263f 0%, #244568 52%, #31597d 100%);
  }
  .desktop-home-tile-ink .desktop-home-spotlight-label,
  .desktop-home-tile-ink p,
  .desktop-home-tile-ink .desktop-home-tile-footer {
    color: rgba(245, 247, 251, 0.86);
  }
  .desktop-home-tile-ink .desktop-home-arrow {
    background: rgba(255, 255, 255, 0.12);
  }
  .desktop-home-tile-copper {
    background: linear-gradient(145deg, #fff3ea 0%, #ffd8c3 52%, #f1ae8d 100%);
  }
  .desktop-home-tile-forest {
    background: linear-gradient(145deg, #eef9ef 0%, #d0f0d7 52%, #b0deb6 100%);
  }
}
@media (min-width: 1024px) {
  .mobile-home-page {
    padding: 42px 30px 60px;
  }
  .desktop-home-tile h3 {
    font-size: 2.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/home/MobileHomePage.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mWACE;EAIF,uBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAHF;;AAMA;EACE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,6DAAA;EACA,cAAA;EACA,0DAAA;EACA,8CAAA;AAHF;;AAMA;EACE,qCAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,yHACE;EACF,cAAA;EACA,8CAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6FAAA;AAJF;;AAOA;;EAEE,kBAAA;EACA,UAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qCAAA;EACA,cAAA;EACA,2DAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,oDAAA;EACA,sCAAA;EACA,iBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,SAAA;EACA,gCAAA;EACA,0DAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAJF;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,kDAAA;AAJF;;AAOA;EACE,wDAAA;AAJF;;AAOA;;EAEE,gCAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAJF;;AAOA;EACE,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,2DAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,cAAA;EACA,2DAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,iFAAA;EACA,uBAAA;AAJF;;AAOA;EACE,SAAA;EACA,cAAA;EACA,8DAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;AAJF;;AAOA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2FAAA;AAJF;;AAOA;EACE,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;EACA,0DAAA;AAJF;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,2DAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AAJF;;AAOA;EACE,SAAA;EACA,8DAAA;EACA,uBAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8CAAA;EACA,cAAA;EACA,2DAAA;AAJF;;AAOA;EACE,mBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,SAAA;EACA,cAAA;EACA,6DAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8CAAA;EACA,0EAAA;AAJF;;AAOA;;EAEE,2BAAA;EACA,8CAAA;EACA,sBAAA;EACA,aAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;AAJF;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,UAAA;AAJF;;AAOA;;;;;;EAME,kBAAA;EACA,UAAA;AAJF;;AAOA;EACE,2DAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AAJF;;AAOA;EACE,SAAA;EACA,oDAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,SAAA;EACA,4BAAA;EACA,6DAAA;AAJF;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;AAJF;;AAOA;EACE,6BAAA;EACA,6DAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,2DAAA;AAJF;;AAOA;EACE,qCAAA;AAJF;;AAOA;EACE,0EAAA;AAJF;;AAOA;EACE,0EAAA;AAJF;;AAOA;EACE,cAAA;EACA,0EAAA;AAJF;;AAOA;;;EAGE,gCAAA;AAJF;;AAOA;EACE,qCAAA;AAJF;;AAOA;EACE,0EAAA;AAJF;;AAOA;EACE,0EAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAJF;;AAOA;EACE,WAAA;EACA,SAAA;EACA,oCAAA;AAJF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,oCAAA;AAJF;;AAOA;EACE;IACE,uBAAA;EAJF;EAOA;IACE,iBAAA;EALF;EAQA;IACE,aAAA;EANF;EASA;IACE,aAAA;IACA,SAAA;EAPF;EAUA;IACE,yBAAA;IACA,mBAAA;EARF;EAWA;IACE,aAAA;IACA,8DAAA;IACA,SAAA;IACA,oBAAA;EATF;EAYA;;;IAGE,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,8CAAA;EAVF;EAaA;IACE,uBAAA;IACA,cAAA;IACA,wNACE;EAZJ;EAgBA;IACE,gBAAA;IACA,+EAAA;IACA,uBAAA;EAdF;EAiBA;IACE,gBAAA;IACA,SAAA;IACA,gCAAA;IACA,6DAAA;EAfF;EAkBA;IACE,aAAA;IACA,SAAA;IACA,gBAAA;EAhBF;EAmBA;IACE,aAAA;IACA,eAAA;IACA,SAAA;IACA,gBAAA;EAjBF;EAoBA;IACE,oBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IACA,oCAAA;IACA,+BAAA;IACA,2DAAA;IACA,sBAAA;EAlBF;EAqBA;IACE,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,SAAA;IACA,aAAA;IACA,cAAA;EAnBF;EAsBA;IACE,yKACE;EArBJ;EAyBA;IACE,SAAA;IACA,6DAAA;IACA,uBAAA;EAvBF;EA0BA;IACE,aAAA;IACA,gDAAA;IACA,SAAA;IACA,eAAA;EAxBF;EA2BA;IACE,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;EAzBF;EA4BA;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA1BF;EA6BA;IACE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,yFAAA;EA3BF;EA8BA;IACE,kBAAA;IACA,0BAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;IACA,cAAA;IACA,6DAAA;IACA,sBAAA;IACA,yBAAA;EA5BF;EA+BA;IACE,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,qCAAA;IACA,2BAAA;IACA,eAAA;EA7BF;EAgCA;;IAEE,SAAA;IACA,0DAAA;EA9BF;EAiCA;IACE,oBAAA;IACA,kBAAA;IACA,oBAAA;IACA,iBAAA;IACA,qCAAA;IACA,2DAAA;IACA,sBAAA;IACA,yBAAA;EA/BF;EAkCA;IACE,kBAAA;IACA,SAAA;IACA,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,qCAAA;IACA,cAAA;IACA,2DAAA;EAhCF;EAmCA;IACE,qCAAA;EAjCF;EAoCA;IACE,aAAA;IACA,iDAAA;IACA,SAAA;EAlCF;EAqCA;IACE,aAAA;IACA,SAAA;IACA,uBAAA;IACA,gBAAA;IACA,SAAA;IACA,eAAA;IACA,cAAA;IACA,uDAAA;EAnCF;EAsCA;;IAEE,2BAAA;IACA,8CAAA;IACA,aAAA;EApCF;EAuCA;IACE,mBAAA;EArCF;EAwCA;IACE,mBAAA;EAtCF;EAyCA;IACE,mBAAA;EAvCF;EA0CA;IACE,oBAAA;EAxCF;EA2CA;IACE,SAAA;IACA,2DAAA;IACA,uBAAA;EAzCF;EA4CA;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;IACA,6DAAA;IACA,yBAAA;IACA,sBAAA;EA1CF;EA6CA;IACE,aAAA;IACA,eAAA;IACA,yBAAA;IACA,SAAA;EA3CF;EA8CA;IACE,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;IACA,iCAAA;EA5CF;EA+CA;IACE,kCAAA;EA7CF;EAgDA;IACE,0EAAA;EA9CF;EAiDA;IACE,cAAA;IACA,0EAAA;EA/CF;EAkDA;;;IAGE,gCAAA;EAhDF;EAmDA;IACE,qCAAA;EAjDF;EAoDA;IACE,0EAAA;EAlDF;EAqDA;IACE,0EAAA;EAnDF;AACF;AAsDA;EACE;IACE,uBAAA;EApDF;EAuDA;IACE,iBAAA;EArDF;AACF","sourcesContent":[".mobile-home-page {\n  --ink: #102033;\n  --muted: #4b6179;\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at top left, rgba(245, 162, 93, 0.32) 0%, rgba(245, 162, 93, 0) 28%),\n    radial-gradient(circle at 90% 12%, rgba(72, 136, 222, 0.2) 0%, rgba(72, 136, 222, 0) 24%),\n    radial-gradient(circle at bottom right, rgba(18, 117, 161, 0.24) 0%, rgba(18, 117, 161, 0) 32%),\n    linear-gradient(180deg, #fff7ec 0%, #f6f3ef 38%, #e7edf4 100%);\n  padding: 24px 18px 40px;\n  box-sizing: border-box;\n}\n\n.mobile-home-shell {\n  position: relative;\n  z-index: 1;\n  max-width: 520px;\n  margin: 0 auto;\n}\n\n.mobile-home-mobile-layout {\n  display: block;\n}\n\n.desktop-home-layout {\n  display: none;\n}\n\n.mobile-home-top-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.mobile-home-top-button {\n  border: 0;\n  border-radius: 999px;\n  padding: 12px 16px;\n  cursor: pointer;\n  background: linear-gradient(135deg, #193e6d 0%, #2c73c6 100%);\n  color: #fff9f0;\n  font: 700 0.9rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  box-shadow: 0 12px 28px rgba(22, 53, 92, 0.18);\n}\n\n.mobile-home-top-button-secondary {\n  background: rgba(255, 255, 255, 0.78);\n  color: #163355;\n}\n\n.mobile-home-hero {\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  gap: 18px;\n  margin-bottom: 18px;\n  padding: 28px 24px;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 34px;\n  background:\n    linear-gradient(145deg, rgba(13, 24, 41, 0.97) 0%, rgba(26, 59, 95, 0.93) 44%, rgba(201, 101, 48, 0.84) 100%);\n  color: #fffaf2;\n  box-shadow: 0 28px 60px rgba(17, 32, 53, 0.24);\n}\n\n.mobile-home-hero::before {\n  content: '';\n  position: absolute;\n  inset: auto -60px -90px auto;\n  width: 220px;\n  height: 220px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 214, 162, 0.26) 0%, rgba(255, 214, 162, 0) 70%);\n}\n\n.mobile-home-hero-copy,\n.mobile-home-hero-panel {\n  position: relative;\n  z-index: 1;\n}\n\n.mobile-home-kicker {\n  display: inline-flex;\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffe7c9;\n  font: 700 0.76rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.mobile-home-hero h1 {\n  margin: 0 0 12px;\n  font-family: 'Trebuchet MS', 'Gill Sans', sans-serif;\n  font-size: clamp(2.25rem, 7vw, 4.4rem);\n  line-height: 0.95;\n  letter-spacing: -0.05em;\n}\n\n.mobile-home-hero p {\n  margin: 0;\n  color: rgba(255, 250, 242, 0.88);\n  font: 500 1rem/1.6 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-hero-panel {\n  display: grid;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(14px);\n}\n\n.mobile-home-hero-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n  gap: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.mobile-home-hero-stat strong {\n  font: 800 2rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-hero-stat span,\n.mobile-home-hero-tags span {\n  color: rgba(255, 250, 242, 0.86);\n}\n\n.mobile-home-hero-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.mobile-home-hero-tags span {\n  border-radius: 999px;\n  padding: 8px 11px;\n  background: rgba(255, 255, 255, 0.1);\n  font: 700 0.82rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-intro-strip {\n  display: grid;\n  gap: 10px;\n  margin-bottom: 18px;\n  padding: 18px 4px 4px;\n}\n\n.mobile-home-section-label {\n  display: inline-flex;\n  color: #81563d;\n  font: 700 0.78rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.mobile-home-intro-strip h2 {\n  margin: 8px 0 0;\n  color: #13263e;\n  font: 800 clamp(1.5rem, 4vw, 2.2rem)/1.02 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: -0.04em;\n}\n\n.mobile-home-intro-strip p {\n  margin: 0;\n  color: #56687d;\n  font: 500 0.98rem/1.55 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-visual-strip {\n  display: grid;\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.mobile-home-visual-card {\n  position: relative;\n  overflow: hidden;\n  min-height: 170px;\n  border-radius: 28px;\n  box-shadow: 0 18px 36px rgba(28, 42, 67, 0.12);\n}\n\n.mobile-home-visual-card img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.mobile-home-visual-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(10, 18, 30, 0.05) 0%, rgba(10, 18, 30, 0.68) 100%);\n}\n\n.mobile-home-visual-overlay {\n  position: absolute;\n  inset: auto 14px 14px 14px;\n  z-index: 1;\n  display: flex;\n  align-items: end;\n  gap: 12px;\n  color: #fffaf2;\n}\n\n.mobile-home-visual-symbol {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.18);\n  backdrop-filter: blur(10px);\n  font: 800 1.1rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-visual-label {\n  display: block;\n  margin-bottom: 4px;\n  font: 700 0.72rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  opacity: 0.82;\n}\n\n.mobile-home-visual-overlay h3 {\n  margin: 0;\n  font: 800 1.45rem/0.96 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: -0.04em;\n}\n\n.mobile-home-symbol-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.mobile-home-symbol-row span {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 10px 13px;\n  background: rgba(255, 255, 255, 0.72);\n  box-shadow: 0 12px 24px rgba(28, 42, 67, 0.08);\n  color: #1a3558;\n  font: 700 0.82rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-footer {\n  padding: 28px 0 6px;\n  text-align: center;\n}\n\n.mobile-home-footer p {\n  margin: 0;\n  color: #17314f;\n  font: 700 0.95rem/1.4 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-grid {\n  display: grid;\n  gap: 18px;\n}\n\n.mobile-home-card {\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  gap: 12px;\n  width: 100%;\n  padding: 24px 20px;\n  border: 0;\n  border-radius: 28px;\n  text-align: left;\n  cursor: pointer;\n  color: var(--ink);\n  box-shadow: 0 18px 36px rgba(28, 42, 67, 0.13);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n}\n\n.mobile-home-card:hover,\n.mobile-home-card:focus-visible {\n  transform: translateY(-4px);\n  box-shadow: 0 26px 48px rgba(28, 42, 67, 0.18);\n  filter: saturate(1.04);\n  outline: none;\n}\n\n.mobile-home-card::after {\n  content: '';\n  position: absolute;\n  right: -18px;\n  top: -30px;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.mobile-home-card-orb {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.28);\n  z-index: 1;\n}\n\n.mobile-home-card h2,\n.mobile-home-card p,\n.mobile-home-card-eyebrow,\n.mobile-home-card-cta,\n.mobile-home-card-footer,\n.mobile-home-card-meta {\n  position: relative;\n  z-index: 1;\n}\n\n.mobile-home-card-eyebrow {\n  font: 700 0.76rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  opacity: 0.78;\n}\n\n.mobile-home-card h2 {\n  margin: 0;\n  font-family: 'Trebuchet MS', 'Gill Sans', sans-serif;\n  font-size: 1.7rem;\n  line-height: 0.98;\n  letter-spacing: -0.04em;\n}\n\n.mobile-home-card p {\n  margin: 0;\n  color: rgba(16, 32, 51, 0.8);\n  font: 500 0.98rem/1.5 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.mobile-home-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.mobile-home-card-meta {\n  color: rgba(16, 32, 51, 0.64);\n  font: 700 0.82rem/1.2 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.mobile-home-card-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  width: fit-content;\n  padding: 10px 14px;\n  border-radius: 999px;\n  background: rgba(16, 32, 51, 0.1);\n  font: 700 0.92rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.mobile-home-card-cta-secondary {\n  background: rgba(255, 255, 255, 0.52);\n}\n\n.mobile-home-card-sunrise {\n  background: linear-gradient(145deg, #fff1d8 0%, #ffd9b3 55%, #ffc18e 100%);\n}\n\n.mobile-home-card-ocean {\n  background: linear-gradient(145deg, #e7f7ff 0%, #cfeeff 50%, #a7d9fb 100%);\n}\n\n.mobile-home-card-ink {\n  color: #f5f6fb;\n  background: linear-gradient(145deg, #1a2740 0%, #233f63 55%, #31587b 100%);\n}\n\n.mobile-home-card-ink p,\n.mobile-home-card-ink .mobile-home-card-eyebrow,\n.mobile-home-card-ink .mobile-home-card-meta {\n  color: rgba(245, 246, 251, 0.82);\n}\n\n.mobile-home-card-ink .mobile-home-card-cta {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.mobile-home-card-copper {\n  background: linear-gradient(145deg, #fff3ea 0%, #ffd8c3 52%, #f1ae8d 100%);\n}\n\n.mobile-home-card-forest {\n  background: linear-gradient(145deg, #eef9ef 0%, #d0f0d7 52%, #b0deb6 100%);\n}\n\n.mobile-home-glow {\n  position: absolute;\n  width: 240px;\n  height: 240px;\n  border-radius: 50%;\n  filter: blur(22px);\n  opacity: 0.44;\n}\n\n.mobile-home-glow-left {\n  left: -80px;\n  top: 40px;\n  background: rgba(242, 166, 105, 0.5);\n}\n\n.mobile-home-glow-right {\n  right: -90px;\n  bottom: 60px;\n  background: rgba(62, 146, 196, 0.38);\n}\n\n@media (min-width: 768px) {\n  .mobile-home-page {\n    padding: 38px 24px 54px;\n  }\n\n  .mobile-home-shell {\n    max-width: 1180px;\n  }\n\n  .mobile-home-mobile-layout {\n    display: none;\n  }\n\n  .desktop-home-layout {\n    display: grid;\n    gap: 22px;\n  }\n\n  .mobile-home-top-actions {\n    justify-content: flex-end;\n    margin-bottom: 18px;\n  }\n\n  .desktop-home-hero {\n    display: grid;\n    grid-template-columns: minmax(0, 1.15fr) minmax(360px, 0.85fr);\n    gap: 22px;\n    align-items: stretch;\n  }\n\n  .desktop-home-copy,\n  .desktop-home-spotlight,\n  .desktop-home-tile {\n    position: relative;\n    overflow: hidden;\n    border-radius: 34px;\n    box-shadow: 0 28px 58px rgba(18, 31, 51, 0.15);\n  }\n\n  .desktop-home-copy {\n    padding: 34px 34px 30px;\n    color: #fffaf2;\n    background:\n      radial-gradient(circle at top right, rgba(253, 209, 151, 0.22) 0%, rgba(253, 209, 151, 0) 30%),\n      linear-gradient(145deg, rgba(13, 24, 41, 0.98) 0%, rgba(24, 54, 90, 0.95) 58%, rgba(182, 93, 38, 0.86) 100%);\n  }\n\n  .desktop-home-copy h1 {\n    margin: 0 0 14px;\n    font: 800 clamp(3rem, 4vw, 4.9rem)/0.94 'Trebuchet MS', 'Gill Sans', sans-serif;\n    letter-spacing: -0.06em;\n  }\n\n  .desktop-home-copy p {\n    max-width: 640px;\n    margin: 0;\n    color: rgba(255, 250, 242, 0.84);\n    font: 500 1.02rem/1.7 'Trebuchet MS', 'Gill Sans', sans-serif;\n  }\n\n  .desktop-home-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 24px;\n  }\n\n  .desktop-home-symbol-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 20px;\n  }\n\n  .desktop-home-symbol-row span {\n    display: inline-flex;\n    align-items: center;\n    border-radius: 999px;\n    padding: 10px 14px;\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 250, 242, 0.9);\n    font: 700 0.82rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n    letter-spacing: 0.04em;\n  }\n\n  .desktop-home-spotlight {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 28px;\n    color: #fff9f2;\n  }\n\n  .desktop-home-spotlight-primary {\n    background:\n      radial-gradient(circle at top left, rgba(255, 244, 210, 0.18) 0%, rgba(255, 244, 210, 0) 28%),\n      linear-gradient(145deg, #13517f 0%, #0f3153 45%, #08233d 100%);\n  }\n\n  .desktop-home-spotlight h2 {\n    margin: 0;\n    font: 800 2.4rem/0.96 'Trebuchet MS', 'Gill Sans', sans-serif;\n    letter-spacing: -0.05em;\n  }\n\n  .desktop-home-photo-stack {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 10px;\n    margin-top: 8px;\n  }\n\n  .desktop-home-photo-card {\n    position: relative;\n    overflow: hidden;\n    min-height: 180px;\n    border-radius: 22px;\n  }\n\n  .desktop-home-photo-card img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .desktop-home-photo-card::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(180deg, rgba(8, 16, 30, 0.02) 0%, rgba(8, 16, 30, 0.62) 100%);\n  }\n\n  .desktop-home-photo-overlay {\n    position: absolute;\n    inset: auto 12px 12px 12px;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    color: #fffaf2;\n    font: 700 0.82rem/1.2 'Trebuchet MS', 'Gill Sans', sans-serif;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  .desktop-home-photo-symbol {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.15);\n    backdrop-filter: blur(10px);\n    font-size: 1rem;\n  }\n\n  .desktop-home-spotlight p,\n  .desktop-home-tile p {\n    margin: 0;\n    font: 500 1rem/1.6 'Trebuchet MS', 'Gill Sans', sans-serif;\n  }\n\n  .desktop-home-spotlight-label {\n    display: inline-flex;\n    width: fit-content;\n    border-radius: 999px;\n    padding: 8px 12px;\n    background: rgba(255, 255, 255, 0.12);\n    font: 700 0.75rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n  }\n\n  .desktop-home-tile-link {\n    width: fit-content;\n    border: 0;\n    border-radius: 999px;\n    padding: 12px 16px;\n    cursor: pointer;\n    background: rgba(255, 255, 255, 0.14);\n    color: #fff9f2;\n    font: 700 0.92rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  }\n\n  .desktop-home-tile-link-secondary {\n    background: rgba(255, 255, 255, 0.24);\n  }\n\n  .desktop-home-mosaic {\n    display: grid;\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n    gap: 22px;\n  }\n\n  .desktop-home-tile {\n    display: grid;\n    gap: 12px;\n    padding: 24px 24px 22px;\n    text-align: left;\n    border: 0;\n    cursor: pointer;\n    color: #13263e;\n    transition: transform 0.18s ease, box-shadow 0.18s ease;\n  }\n\n  .desktop-home-tile:hover,\n  .desktop-home-tile:focus-visible {\n    transform: translateY(-4px);\n    box-shadow: 0 32px 62px rgba(18, 31, 51, 0.18);\n    outline: none;\n  }\n\n  .desktop-home-tile:nth-child(1) {\n    grid-column: span 4;\n  }\n\n  .desktop-home-tile:nth-child(2) {\n    grid-column: span 4;\n  }\n\n  .desktop-home-tile:nth-child(3) {\n    grid-column: span 4;\n  }\n\n  .desktop-home-tile:nth-child(4) {\n    grid-column: span 12;\n  }\n\n  .desktop-home-tile h3 {\n    margin: 0;\n    font: 800 2rem/0.96 'Trebuchet MS', 'Gill Sans', sans-serif;\n    letter-spacing: -0.05em;\n  }\n\n  .desktop-home-tile-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 14px;\n    margin-top: auto;\n    font: 700 0.85rem/1.2 'Trebuchet MS', 'Gill Sans', sans-serif;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .desktop-home-tile-actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 10px;\n  }\n\n  .desktop-home-arrow {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 0;\n    cursor: pointer;\n    border-radius: 999px;\n    padding: 10px 14px;\n    background: rgba(16, 32, 51, 0.1);\n  }\n\n  .desktop-home-arrow-secondary {\n    background: rgba(16, 32, 51, 0.06);\n  }\n\n  .desktop-home-tile-ocean {\n    background: linear-gradient(145deg, #e8f7ff 0%, #cdeafe 50%, #aedcfa 100%);\n  }\n\n  .desktop-home-tile-ink {\n    color: #f5f7fb;\n    background: linear-gradient(145deg, #18263f 0%, #244568 52%, #31597d 100%);\n  }\n\n  .desktop-home-tile-ink .desktop-home-spotlight-label,\n  .desktop-home-tile-ink p,\n  .desktop-home-tile-ink .desktop-home-tile-footer {\n    color: rgba(245, 247, 251, 0.86);\n  }\n\n  .desktop-home-tile-ink .desktop-home-arrow {\n    background: rgba(255, 255, 255, 0.12);\n  }\n\n  .desktop-home-tile-copper {\n    background: linear-gradient(145deg, #fff3ea 0%, #ffd8c3 52%, #f1ae8d 100%);\n  }\n\n  .desktop-home-tile-forest {\n    background: linear-gradient(145deg, #eef9ef 0%, #d0f0d7 52%, #b0deb6 100%);\n  }\n}\n\n@media (min-width: 1024px) {\n  .mobile-home-page {\n    padding: 42px 30px 60px;\n  }\n\n  .desktop-home-tile h3 {\n    font-size: 2.2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
